/**
 * Ce que la route de la page des recompenses de points lit sans charger la page : son adresse. La route (`route.tsx`),
 * l'index des reglages (`reglages/reglages-texts.ts`) et le lien de l'ecran « Boosters » sont dans le paquet d'entree,
 * que Vite signale au-dela de 500 ko : ils n'importent donc que ce fichier, jamais `recompenses.tsx`, `recompenses-api.ts`
 * ni `recompenses-texts.ts` (`route.test.tsx` le verifie, comme `routes.test.tsx` pour la diffusion et l'ecran En direct).
 */

export const RECOMPENSES_PATH = "/regie/reglages/recompenses";
